export const EVENT_CATEGORIES = [
  { id: "promotional-menu", label: "Promotional menu" },
  { id: "promotional-item", label: "Promotional item" },
  { id: "live-music", label: "Live music" },
  { id: "tasting", label: "Tasting" },
  { id: "special-occasion", label: "Special occasion" },
  { id: "private-event", label: "Private event" },
  { id: "other", label: "Other" },
];
export const categoryLabel = (id) =>
  EVENT_CATEGORIES.find((category) => category.id === id)?.label || "Event";
